import i18next from "src/i18n/config";

import { createDeviceMdmCommand } from "@dashboard/devices/api/devices";
import { createStreamSession, getDeviceStreamLog } from "@dashboard/devices/api/stream";
import { License } from "@devices/types";
import RouteService from "@services/routeService";

async function onDeviceCommandStartExecutable(deviceId: number, sessionId: string) {
    const route = await RouteService.getStreamRoute();
    await createDeviceMdmCommand({
        deviceId,
        json: {
            command: "startExecutable",
            caption: "Show Logcat output",
            executable: `logcat -d | curl -T- -X PUT ${route}stream/${sessionId}`,
        },
    });
}
export async function onStartStreaming(deviceId: number | undefined, workspaceId: number | null) {
    if (!deviceId) {
        throw new Error(i18next.t("sidepanels:devicePanel.toast.noDeviceLogsAvailable"));
    }
    if (workspaceId === null) {
        throw new Error(i18next.t("common:toast.noWorkspaceIdFound"));
    }
    const sessionId = await createStreamSession(workspaceId, "Http");
    const response = getDeviceStreamLog(sessionId);
    await onDeviceCommandStartExecutable(deviceId, sessionId);
    return response;
}
export function getReasonMessage(limit: number, license: License) {
    if (!license.device?.id) {
        return i18next.t("sidepanels:devicePanel.tooltip.noDevice");
    } else if (!license.device?.isOnline) {
        return i18next.t("sidepanels:devicePanel.tooltip.deviceOffline");
    } else if (limit === 0) {
        return i18next.t("common:section.logStreamer.streamLimitReached");
    }
    return i18next.t("sidepanels:devicePanel.tooltip.logStreamingForThisDevice");
}
